import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import spacing from '../../design-system/spacing';
import shadows from '../../design-system/shadows';
import typography from '../../design-system/typography';

const TableRenderer = ({ data }) => {
  const theme = useTheme();
  if (!data) return null;

  const { title, headers = [], rows = [] } = data;

  if (!headers.length || !rows.length) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
        No hay datos disponibles para la tabla.
      </Typography>
    );
  }

  return (
    <Box sx={{ my: 1 }}>
      {title && (
        <Typography
          variant="subtitle2"
          sx={{
            mb: 1,
            fontWeight: typography.fontWeight.semibold,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
      )}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: `${spacing.borderRadius.md}px`,
          boxShadow: shadows.card,
          overflow: 'auto',
          maxHeight: 360,
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    fontWeight: typography.fontWeight.bold,
                    fontSize: typography.fontSize.xs,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    py: 1,
                    px: 1.5,
                    borderBottom: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  // Zebra striping and hover use theme.palette.background/action so
                  // rows never render as an opaque white block against a dark app.
                  backgroundColor:
                    rowIndex % 2 === 0 ? 'background.paper' : 'action.hover',
                  '&:hover': { backgroundColor: 'action.selected' },
                  transition: 'background-color 0.15s ease',
                }}
              >
                {(Array.isArray(row) ? row : headers.map((_, i) => row[i])).map(
                  (cell, cellIndex) => (
                    <TableCell
                      key={cellIndex}
                      sx={{
                        fontSize: typography.fontSize.xs,
                        py: 0.8,
                        px: 1.5,
                        color: 'text.primary',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                      }}
                    >
                      {cell != null ? String(cell) : '-'}
                    </TableCell>
                  )
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableRenderer;
